<form #f="ngForm">
    <div>
        <div class="dashed-line mb-4 pb-4 pt-3">
            <h5 class="labelText"> Enter the LCA Details</h5>
            <div class="row pt-2">

                <!--4605--->
                <div *ngIf="lcaType == 'certifiedLCA'" class="col-3 mt-1 pl-3">

                    <label class="control-lbl required mt-2 label-cls">Is this a certified LCA ?</label>
                    <div class="row pt-2">
                        <mat-radio-group name="isCertifiedLCA" aria-label="Select an option" required
                            [(ngModel)]="lca.isCertifiedLCA">
                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                            <mat-radio-button [value]="false">No </mat-radio-button>
                        </mat-radio-group>
                    </div>

                </div>

                <div class="col-3 pl-0">
                    <label class="mt-2 label-cls control-lbl required">Case Number</label>
                    <input type="text" class="im-input" name="caseNumber" [(ngModel)]="lca.caseNumber"
                        pattern="[A-Z][-]\d{3}[-]\d{5}[-]\d{6}" placeholder="Enter" #caseNumber="ngModel"
                        [readonly]="enableReadOnlyMode" required />
                    <mat-hint>Example: G-100-12345-123456</mat-hint>
                    <div class="invalid-message"
                        *ngIf="(caseNumber.touched || f.submitted) && caseNumber.errors?.required">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </div>
                    <div class="invalid-message"
                        *ngIf="(caseNumber.touched || f.submitted) && caseNumber.errors?.pattern">
                        {{ getGlobalErrorMessages("INVALID_NUMBER") }}
                    </div>
                </div>

                <div class="col-3 pl-0">
                    <label class="control-lbl mt-2 label-cls d-block required">Applied Date</label>
                    <mat-form-field class="matformfieldwidth1 w-100 date-field" appearance="outline">
                        <input [(ngModel)]="lca.lcaAppliedDate" [max]="maxDate" name="lcaAppliedDateRef" matInput
                            [matDatepicker]="lcaAppliedDate" #lcaAppliedDateRef="ngModel"
                            (click)="lcaAppliedDate.open()" required placeholder="MM/DD/YYYY">
                        <mat-datepicker-toggle matSuffix [for]="lcaAppliedDate"></mat-datepicker-toggle>
                        <mat-datepicker #lcaAppliedDate></mat-datepicker>
                    </mat-form-field>
                    <div class="invalid-message"
                        *ngIf="(lcaAppliedDateRef.touched || f.submitted) && lcaAppliedDateRef.errors?.required">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </div>
                </div>

                <div *ngIf="lcaType == 'certifiedLCA'" class="col-3 pl-0">
                    <label class="control-lbl mt-2 label-cls d-block required">Certified Date</label>
                    <mat-form-field class="matformfieldwidth1 w-100 date-field" appearance="outline">
                        <input [(ngModel)]="lca.certifiedDate" [max]="maxDate" name="certifiedDateRef" matInput
                            [matDatepicker]="certifiedDate" #certifiedDateRef="ngModel" placeholder="MM/DD/YYYY"
                            (click)="certifiedDate.open()" required>
                        <mat-datepicker-toggle matSuffix [for]="certifiedDate"></mat-datepicker-toggle>
                        <mat-datepicker #certifiedDate></mat-datepicker>
                    </mat-form-field>
                    <div class="invalid-message"
                        *ngIf="(certifiedDateRef.touched || f.submitted) && certifiedDateRef.errors?.required">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </div>
                </div>
            </div>
        </div>
        <!-- IM-4156-Validation error message appears as soon as Create New LCA button clicked -->

        <div class="dashed-line mb-4  pb-4">
            <h5 class="labelText"> Employment-Based Nonimmigrant Visa Information</h5>

            <div class="row headrgap">
                <div class="col-4 pl-0">
                    <label class="control-lbl required mt-2 label-cls">Visa Classification Type</label>
                    <select class="im-input col-md" [(ngModel)]="lca.visaType" name="visaType" #visaType="ngModel"
                        (change)="onChangeVisa()" required>
                        <option *ngFor="let item of visaTypeList" [value]="item.code">
                            {{item.name}}</option>
                    </select>
                </div>
            </div>
            <div class="invalid-message" *ngIf="(visaType.touched || f.submitted) && visaType.errors?.required">
                {{ getGlobalErrorMessages("REQUIRED") }}
            </div>
        </div>
        <div class="dashed-line mb-4  pb-4">
            <h5 class="labelText">Temporary Need Information</h5>

            <div class="row headrgap">
                <div class="col-4 pl-0">
                    <label class="control-lbl required mt-2 label-cls">Job Title</label>
                    <input type="text" class="im-input" name="jobTitle" [(ngModel)]="lca.jobTitle" placeholder="Enter"
                        #jobTitle="ngModel" [readonly]="enableReadOnlyMode" required />
                    <span class="invalid-message"
                        *ngIf="(jobTitle.touched || f.submitted) && jobTitle.errors?.required">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </div>


                <div class="col-4 lca-soc-code">
                    <mat-label class="label-cls">SOC (ONET/OES) code</mat-label>
                    <mat-form-field>
                        <!-- <label class="control-lbl required  label-cls">SOC (ONET/OES) code</label> -->
                        <mat-select class="im-input col-md" name="socCode" #socCode="ngModel" [(ngModel)]="lca.socCode"
                            (selectionChange)="onChangeOccupationTitle($event.value)" (mouseover)="getListSocCOde()">
                            <input placeholder="search soc codes" (keyup)="onKey($event.target.value)">
                            <!-- <mat-option>None</mat-option> -->
                            <ng-container *ngFor="let item of socCodeListFiltered">
                                <mat-option [value]="item?.socCode">
                                    {{item?.socCode}} ({{item?.version}})
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                    <!-- <span class="invalid-message" *ngIf="(socCode.touched || f.submitted) && socCode.errors?.required">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span> -->
                    <!-- <label class="control-lbl required mt-2 label-cls">SOC (ONET/OES) code</label>
                <input type="text" class="im-input" name="socCode" [(ngModel)]="lca.socCode" placeholder="Enter"
                    #socCode="ngModel" [readonly]="enableReadOnlyMode" required>
                    <mat-hint>Example: 12-1234.00</mat-hint>
                <span class="invalid-message" *ngIf="(socCode.touched || f.submitted) && socCode.errors?.required">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span> -->
                </div>

                <div class="col-4">
                    <label class="control-lbl required mt-2 label-cls">SOC (ONET/OES) occupation title</label>
                    <input type="text" class="im-input" name="socTitle" [(ngModel)]="lca.socTitle" placeholder="Enter"
                        #socTitle="ngModel" [readonly]="enableReadOnlyModes" required>
                    <!-- <mat-hint>Example: 12-1234.00</mat-hint> -->
                    <span class="invalid-message"
                        *ngIf="(socTitle.touched || f.submitted) && socTitle.errors?.required">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </div>



            </div>



            <div class="row">
                <div class="col-4 mt-1 pl-0">
                    <label class="control-lbl mt-2 label-cls">Is this a full-time position?</label>
                    <div class="row">
                        <mat-radio-group name="isFullTime" aria-label="Select an option" [(ngModel)]="lca.isFullTime">
                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                            <mat-radio-button [value]="false">No </mat-radio-button>
                        </mat-radio-group>
                    </div>

                </div>

                <div class="col-4 mt-1">
                    <label class="control-lbl mt-2 label-cls d-block required">Employment Start Date</label>
                    <mat-form-field class="matformfieldwidth1 w-100 date-field" appearance="outline">
                        <input [(ngModel)]="lca.employmentStartDate" name="employmentStartDate" matInput
                            [matDatepicker]="employmentStart" #employmentStartDate="ngModel"
                            (dateChange)="onChangeEndDate()" (click)="employmentStart.open()" placeholder="MM/DD/YYYY"
                            required>
                        <mat-datepicker-toggle matSuffix [for]="employmentStart"></mat-datepicker-toggle>
                        <mat-datepicker #employmentStart></mat-datepicker>
                    </mat-form-field>
                    <div class="invalid-message"
                        *ngIf="(employmentStartDate.touched || f.submitted) && employmentStartDate.errors?.required">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </div>
                    <span class="invalid-message"
                        *ngIf="(lca.visaType ==='H1-B' || lca.visaType ==='H1-B1') && !showDateError">
                        {{ getGlobalErrorMessages("INVALID_H1B") }}
                    </span>
                    <span class="invalid-message" *ngIf="lca.visaType ==='E3' && !showDateError">
                        {{ getGlobalErrorMessages("INVALID_E3") }}
                    </span>

                </div>
                <div class="col-4 mt-1">
                    <label class="control-lbl mt-2 label-cls d-block required">Employment End Date</label>
                    <mat-form-field appearance="outline" class="w-100 date-field">
                        <input (dateChange)="onChangeEndDate()" [(ngModel)]="lca.employmentEndDate"
                            name="employmentEndDate" matInput #employmentEndDate="ngModel"
                            [matDatepicker]="employmentEnd" [min]="lca.employmentStartDate"
                            (click)="employmentEnd.open()" placeholder="MM/DD/YYYY" required>
                        <mat-datepicker-toggle matSuffix [for]="employmentEnd"></mat-datepicker-toggle>
                        <mat-datepicker #employmentEnd></mat-datepicker>
                    </mat-form-field>
                    <div class="invalid-message"
                        *ngIf="(employmentEndDate.touched || f.submitted) && employmentEndDate.errors?.required">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-4 pl-0">
                    <label class="control-lbl required mt-2 label-cls">Total Worker Positions</label>
                    <input type="number" class="im-input" name="totalCount" [(ngModel)]="lca.totalCount"
                        placeholder="Enter" #totalCount="ngModel" required [readonly]="enableReadOnlyMode" />
                    <span class="invalid-message"
                        *ngIf="(totalCount.touched || f.submitted) && totalCount.errors?.required">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </div>
            </div>

            <div class="row" class="font-weight-bold mt-4">
                Indicate total workers in each applicable category
            </div>
            <div class="row headrgap">
                <div class="col-4 pl-0">
                    <label class="control-lbl required mt-2 label-cls">New Employment</label>
                    <input type="number" class="im-input" name="newEmploymentCount" [(ngModel)]="lca.newEmploymentCount"
                        placeholder="Enter" min="0" #newEmploymentCount="ngModel" required
                        [readonly]="enableReadOnlyMode" />
                    <span class="invalid-message"
                        *ngIf="(newEmploymentCount.touched || f.submitted) && newEmploymentCount.errors?.required">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </div>
                <div class="col-4">
                    <label class="control-lbl required mt-2 label-cls">Continution of Employment</label>
                    <input type="number" min="0" class="im-input" name="continueApprovedCount"
                        [(ngModel)]="lca.continueApprovedCount" placeholder="Enter" #continueApprovedCount="ngModel"
                        required [readonly]="enableReadOnlyMode">
                    <span class="invalid-message"
                        *ngIf="(continueApprovedCount.touched || f.submitted) && continueApprovedCount.errors?.required">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </div>
                <div class="col-4">
                    <label class="control-lbl required mt-2 label-cls">Change in Employment</label>
                    <input type="number" min="0" class="im-input" name="changeApproveCount"
                        [(ngModel)]="lca.changeApproveCount" placeholder="Enter " #changeApproveCount="ngModel" required
                        [readonly]="enableReadOnlyMode">
                    <span class="invalid-message"
                        *ngIf="(changeApproveCount.touched || f.submitted) && changeApproveCount.errors?.required">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-4 pl-0">
                    <label class="control-lbl required mt-2 label-cls">New Concurrent Employment</label>
                    <input type="number" min="0" class="im-input" name="concurrentEmploymentCount"
                        [(ngModel)]="lca.concurrentEmploymentCount" placeholder="Enter"
                        #concurrentEmploymentCount="ngModel" required [readonly]="enableReadOnlyMode" />
                    <span class="invalid-message"
                        *ngIf="(concurrentEmploymentCount.touched || f.submitted) && concurrentEmploymentCount.errors?.required">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </div>
                <div class="col-4">
                    <label class="control-lbl required mt-2 label-cls">Change in Employer</label>
                    <input type="number" min="0" class="im-input" name="employerChangeCount"
                        [(ngModel)]="lca.employerChangeCount" placeholder="Enter " #employerChangeCount="ngModel"
                        required [readonly]="enableReadOnlyMode">
                    <span class="invalid-message"
                        *ngIf="(employerChangeCount.touched || f.submitted) && employerChangeCount.errors?.required">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </div>
                <div class="col-4">
                    <label class="control-lbl required mt-2 label-cls">Amended Petition</label>
                    <input type="number" min="0" class="im-input" name="amendedPetitionCount"
                        [(ngModel)]="lca.amendedPetitionCount" placeholder="Enter " #amendedPetitionCount="ngModel"
                        required [readonly]="enableReadOnlyMode">
                    <span class="invalid-message"
                        *ngIf="(amendedPetitionCount.touched || f.submitted) && amendedPetitionCount.errors?.required">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </div>
            </div>
        </div>
        <div class="dashed-line mb-4 pb-4">
            <h5 class="labelText">Employer Information</h5>



            <div class="row mt-2 mb-4 headrgap" *ngIf="userType !='Attorney'">
                <div class="col-4 pl-0">
                    <label class="control-lbl required mt-2 label-cls">Company Name</label>
                    <select [(ngModel)]="lca.companyId" (ngModelChange)="selectedCompany($event)" class="im-input"
                        name="companyId" aria-placeholder="Select lawfirm" #companyId="ngModel" required>
                        <option *ngFor="let item of listCompany" [value]="item.id">
                            {{item.companyName}}
                        </option>
                    </select>
                    <span class="invalid-message"
                        *ngIf="(companyId.touched || f.submitted) && companyId.errors?.required">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </div>
                <div class="col-4 pl-0 paddingTop-5">
                    <label class="label-cls">NAICS Code Number</label>
                    <mat-select name="naicsCode" [(ngModel)]="lca.companyNaicsCode"
                        (selectionChange)="selectedNaics($event.value)">
                        <mat-option *ngFor="let item of listNaics" [value]="item.naicsCode"
                            [matTooltip]="item?.naicsTitle">
                            {{item.naicsTitle}}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
            <div class="row mt-2 mb-4 headrgap" *ngIf="userType ==='Attorney'">
                <div class="col-4 pl-0">
                    <label class="control-lbl required mt-2 label-cls">Company Name</label>
                    <select [(ngModel)]="lca.companyId" (ngModelChange)="selectedCompany($event)" class="im-input"
                        name="companyId" aria-placeholder="Select lawfirm" #companyId="ngModel" required>
                        <option *ngFor="let item of companyListAssociatedWithAttorney" [value]="item.petitionerId">
                            {{item.petitionerName}}
                        </option>
                    </select>
                    <span class="invalid-message"
                        *ngIf="(companyId.touched || f.submitted) && companyId.errors?.required">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </div>
                <div class="col-4 pl-0 paddingTop-5">
                    <label class="label-cls">NAICS Code</label>
                    <mat-select name="naicsCode" [(ngModel)]="lca.companyNaicsCode"
                        (selectionChange)="selectedNaics($event.value)">
                        <mat-option *ngFor="let item of listNaics" [value]="item.naicsCode">
                            {{item.naicsTitle}}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
            <!-- <div class="row mt-2 mb-2">
            <a (click)="toggleExpansion()" class="text-primary small">
                <span *ngIf="!expandPanel">
                    <mat-icon matTooltip="View more details" >expand_more</mat-icon>View Company Details
                </span>
                <span *ngIf="expandPanel">
                    <mat-icon matTooltip="View less details">keyboard_arrow_up</mat-icon> Hide Company Details
                </span>
            </a>
        </div> -->

            <mat-accordion class="mt-4">
                <mat-expansion-panel hideToggle [expanded]="expandPanel">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <b>View company details</b>
                        </mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class="panel-border" *ngIf="userType === 'Attorney'">

                        <!-- <div class="row mt-2"> -->
                        <!-- <div class="col-4 pl-0">
                            <label class="control-lbl">Federal Employer Identification Number</label>
                            <div class="row">{{petitionerInfo?.feiNo}}</div>
                        </div> -->
                        <!-- <div class="col-4">
                            <label class="control-lbl">NAICS Code Number</label>
                            <div class="row">{{petitionerInfo?.naicsCode}}</div>
                        </div> -->
                        <!-- </div> -->

                        <div class="row">
                            <div class="col-4 pl-0">
                                <label class="control-lbl">Federal Employer Identification Number</label>
                                <div class="row">{{petitionerInfo?.feiNo}}</div>
                            </div>
                            <div class="col-4">
                                <label class="control-lbl">Phone Number</label>
                                <div class="row"> {{petitionerInfo?.petitionerOfficePhone}}</div>
                            </div>
                            <div class="col-4">
                                <label class="control-lbl">Ext </label>
                                <div class="row"> {{petitionerInfo?.petitionerPhoneExtension}}</div>
                            </div>
                        </div>

                        <div class="col-6 pl-0 mt-2">
                            <label class="control-lbl">Address</label>
                            <div class="row"> {{petitionerInfo?.petitionerRegisteredAddress?.addressLine1}}</div>
                            <div class="row"> {{petitionerInfo?.petitionerRegisteredAddress?.addressLine2}}</div>
                            <div class="row"> {{petitionerInfo?.petitionerRegisteredAddress?.countryCode?.countryName}}
                            </div>
                            <div class="row"> {{petitionerInfo?.petitionerRegisteredAddress?.city}}</div>
                            <div class="row"> {{petitionerInfo?.petitionerRegisteredAddress?.postCode}}</div>
                        </div>
                    </div>
                    <div class="panel-border" *ngIf="userType != 'Attorney'">
                        <!-- <div class="row mt-2"> -->
                        <!-- <div class="col-4 pl-0">
                            <label class="control-lbl mb-0">Federal Employer Identification Number</label>
                            <div class="row">{{employerInfo?.feiNo}}</div>


                        </div> -->
                        <!-- <div class="col-4">
                            <label class="control-lbl mb-0">NAICS Code Number</label>
                            <div class="row">{{employerInfo?.naicsCode}}</div>
                        </div> -->
                        <!-- </div> -->

                        <div class="row">
                            <div class="col-4 pl-0">
                                <label class="control-lbl mb-0">Federal Employer Identification Number</label>
                                <div class="row">{{employerInfo?.feiNo}}</div>
                            </div>
                            <div class="col-4">
                                <label class="control-lbl mb-0">Phone Number</label>
                                <div class="row"> {{employerInfo?.phoneContacts[0]?.phoneNo}}</div>
                            </div>
                            <div class="col-4">
                                <label class="control-lbl mb-0">Ext </label>
                                <div class="row"> {{employerInfo?.phoneContacts[0]?.extension}}</div>
                            </div>
                        </div>

                        <div class="col-6 pl-0 mt-2">
                            <label class="control-lbl mb-0">Address</label>
                            <div class="row"> {{employerInfo?.address[0]?.addressLine1}}</div>
                            <div class="row"> {{employerInfo?.address[0]?.addressLine2}}</div>
                            <div class="row"> {{employerInfo?.address[0]?.countryCode?.countryName}}</div>
                            <div class="row"> {{employerInfo?.address[0]?.city}}</div>
                            <div class="row"> {{employerInfo?.address[0]?.postCode}}</div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <!----------------Place of Employment Information--------------->

        <ng-container *ngFor="let ix of lca.placeOfEmployments; let idx = index">

            <div class="dashed-top-line mb-4 pb-4 infoBlocks">
                <h5 class="labelText">Place of Employment Information - {{idx+1}} </h5>
                <div class="row">
                    <div class="col-4 pl-0">
                        <label class="control-lbl required mt-2 label-cls">Address 1</label>
                        <input type="text" class="im-input" name="address1{{idx}}"
                            [(ngModel)]="lca.placeOfEmployments[idx].addressDTO.addressLine1"
                            placeholder="Enter Address" #lca.placeOfEmployments[idx].addressDTO.address1="ngModel"
                            required />
                        <span class="invalid-message">
                        </span>
                    </div>

                    <div class="col-4 pl-3">
                        <label class="control-lbl  mt-2 label-cls">Address 2</label>
                        <input type="text" class="im-input" name="address2{{idx}}"
                            [(ngModel)]="lca.placeOfEmployments[idx].addressDTO.addressLine2"
                            placeholder="Enter Address"
                            #lca.placeOfEmployments[idx].addressDTO.addressLine2="ngModel" />
                        <span class="invalid-message">
                        </span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4 pl-0">
                        <mat-form-field>
                            <label class="label-cls required">State/District/Territory</label>
                            <mat-select name="stateDisTerritory{{idx}}"
                                [(ngModel)]="lca.placeOfEmployments[idx].addressDTO.stateProvinceCode"
                                #lca.placeOfEmployments[idx].addressDTO.stateProvinceCode="ngModel" required
                                (selectionChange)="onChangeState($event.value, idx)">
                                <mat-option *ngFor="let item of listStates" [value]="item.stateProvinceCode">
                                    {{item.stateProvinceName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <span class="invalid-message">
                        </span>
                        <!--                     
                    <label class="control-lbl required mt-2 label-cls">City</label>
                    <input type="text" class="im-input" name="city{{idx}}"
                     [(ngModel)]="lca.placeOfEmployments[idx].addressDTO.city"
                     placeholder="Enter City"
                     #lca.placeOfEmployments[idx].addressDTO.city ="ngModel"
                     required/>
                    <span class="invalid-message"> 
                    </span> -->
                    </div>

                    <div class="col-4 pl-3">
                        <!-- <label class="control-lbl required mt-2 label-cls">County</label>
                    <input type="text" class="im-input" name="county{{idx}}"
                     [(ngModel)]="lca.placeOfEmployments[idx].addressDTO.county"
                     placeholder="Enter County"
                     #lca.placeOfEmployments[idx].addressDTO.county ="ngModel"
                     required/>
                    <span class="invalid-message"> 
                    </span> -->

                        <mat-form-field>
                            <label class="label-cls required">County</label>
                            <mat-select name="county{{idx}}"
                                (selectionChange)="getWageLevels(idx, $event, lca.placeOfEmployments[idx].addressDTO.stateProvinceCode, lca.socCode)"
                                [(ngModel)]="lca.placeOfEmployments[idx].addressDTO.county"
                                #lca.placeOfEmployments[idx].addressDTO.county="ngModel" required *ngIf="idx===0">
                                <mat-option *ngFor="let item of listCounty0" [value]="item">
                                    {{item}}
                                </mat-option>
                            </mat-select>
                            <mat-select name="county{{idx}}"
                                (selectionChange)="getWageLevels(idx, $event, lca.placeOfEmployments[idx].addressDTO.stateProvinceCode, lca.socCode)"
                                [(ngModel)]="lca.placeOfEmployments[idx].addressDTO.county"
                                #lca.placeOfEmployments[idx].addressDTO.county="ngModel" required *ngIf="idx===1">
                                <mat-option *ngFor="let item of listCounty1" [value]="item">
                                    {{item}}
                                </mat-option>
                            </mat-select>
                            <mat-select name="county{{idx}}"
                                (selectionChange)="getWageLevels(idx, $event, lca.placeOfEmployments[idx].addressDTO.stateProvinceCode, lca.socCode)"
                                [(ngModel)]="lca.placeOfEmployments[idx].addressDTO.county"
                                #lca.placeOfEmployments[idx].addressDTO.county="ngModel" required *ngIf="idx===2">
                                <mat-option *ngFor="let item of listCounty2" [value]="item">
                                    {{item}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <span class="invalid-message">
                        </span>
                    </div>
                </div>


                <div class="row">
                    <div class="col-4 pl-0">
                        <!-- <label class="control-lbl required mt-2 label-cls">State/District/Territory</label>
                    <input type="text" class="im-input" name="stateDisTerritory{{idx}}"
                     [(ngModel)]="lca.placeOfEmployments[idx].addressDTO.stateProvinceName"
                     placeholder="Enter State/District/Territory"
                     #lca.placeOfEmployments[idx].addressDTO.stateProvinceName ="ngModel"
                     required/>
                    <span class="invalid-message"> 
                    </span>  -->
                        <label class="control-lbl required mt-2 label-cls">City</label>
                        <input type="text" class="im-input" name="city{{idx}}"
                            [(ngModel)]="lca.placeOfEmployments[idx].addressDTO.city" placeholder="Enter City"
                            #lca.placeOfEmployments[idx].addressDTO.city="ngModel" required />
                        <span class="invalid-message">
                        </span>
                    </div>
                    <div class="col-4 pl-3">
                        <label class="control-lbl required mt-2 label-cls">Postal Code</label>
                        <input type="text" class="im-input" name="postalCode{{idx}}"
                            [(ngModel)]="lca.placeOfEmployments[idx].addressDTO.postalCode"
                            placeholder="Enter Postal Code" #lca.placeOfEmployments[idx].addressDTO.postalCode="ngModel"
                            required />
                        <span class="invalid-message">
                        </span>
                    </div>
                </div>
                <div *ngIf="wageResults && wageResults.length > 0 && wageResults[idx]" class="mt-3 pt-1">
                    <label class="control-lbl required mb-3 label-cls">Wage Results</label>
                    <h6 class="mb-3"><b>Showing all Industries database for {{wageResults[idx].yearDuration}}</b></h6>
                    <p class="mb-2"><strong>GeoLevel:</strong> {{wageResults[idx].geoLevel}}</p>
                    <p class="mb-2"><strong>Level 1 Wage:</strong> {{wageResults[idx].level1}}</p>
                    <p class="mb-2"><strong>Level 2 Wage:</strong> {{wageResults[idx].level2}}</p>
                    <p class="mb-2"><strong>Level 3 Wage:</strong> {{wageResults[idx].level3}}</p>
                    <p class="mb-2"><strong>Level 4 Wage:</strong> {{wageResults[idx].level4}}</p>
                </div>
                <div *ngIf="wageResultsEducation && wageResultsEducation.length > 0 && wageResultsEducation[idx]"
                    class="mt-3 pt-1">
                    <label class="control-lbl required mb-3 label-cls">Wage Results</label>
                    <h6 class="mb-3"><b>Showing ACWIA - Education Industry database for
                            {{wageResultsEducation[idx].yearDuration}}</b></h6>
                    <p class="mb-2"><strong>GeoLevel:</strong> {{wageResultsEducation[idx].geoLevel}}</p>
                    <p class="mb-2"><strong>Level 1 Wage:</strong> {{wageResultsEducation[idx].level1}}</p>
                    <p class="mb-2"><strong>Level 2 Wage:</strong> {{wageResultsEducation[idx].level2}}</p>
                    <p class="mb-2"><strong>Level 3 Wage:</strong> {{wageResultsEducation[idx].level3}}</p>
                    <p class="mb-2"><strong>Level 4 Wage:</strong> {{wageResultsEducation[idx].level4}}</p>
                </div>

                <div class="mt-3 pt-1 row segment-div-wrapper-up">
                    <div class="col-4 pl-0">
                        <label class="control-lbl required mt-2 label-cls">Wage paid to non-immigrant - from</label>
                        <input type="number" class="im-input" name="wagePaidToNonImmgtsFrom{{idx}}"
                            [(ngModel)]="lca.placeOfEmployments[idx].wageRangeFrom" placeholder="Enter Amount in $"
                            #lca.placeOfEmployments[idx].wageRangeFrom="ngModel" required />
                        <span class="invalid-message"
                            *ngIf="(lca.placeOfEmployments[idx].prvlWageRate > lca.placeOfEmployments[idx].wageRangeFrom)">
                            {{ getGlobalErrorMessages("INVALID_PREVAILING_WAGE") }}
                        </span>
                    </div>

                    <div class="col-4 pl-3">
                        <label class="control-lbl mt-2 label-cls">Wage paid to non-immigrant - to</label>
                        <input type="number" class="im-input" name="wagePaidToNonImmgtsTo{{idx}}"
                            [(ngModel)]="lca.placeOfEmployments[idx].wageRangeTo" placeholder="Enter Amount in $"
                            #lca.placeOfEmployments[idx].wageRangeTo="ngModel" />
                        <span class="invalid-message"
                            *ngIf="!(lca.placeOfEmployments[idx].wageRangeFrom < lca.placeOfEmployments[idx].wageRangeTo)">
                            {{ getGlobalErrorMessages("INVALID_WAGERANGE") }}
                        </span>
                    </div>
                </div>

                <div class="row  pb-3 ">
                    <div class="col-6 pl-0">
                        <label class="control-lbl required mt-2 label-cls">Wage paid to non-immigrant - per</label>
                        <div class="row">
                            <mat-radio-group class="pt-2" aria-label="Select an option"
                                name="wagePaidToNonImmgtsPer{{idx}}"
                                #lca.placeOfEmployments[idx].wageRangeTypeCode="ngModel"
                                [(ngModel)]="lca.placeOfEmployments[idx].wageRangeTypeCode" required>
                                <mat-radio-button [value]="'HOUR'">Hour</mat-radio-button>
                                <mat-radio-button [value]="'WEEK'">Week</mat-radio-button>
                                <mat-radio-button [value]="'BIWEEKLY'">Bi-Weekly</mat-radio-button>
                                <mat-radio-button [value]="'MONTH'">Month</mat-radio-button>
                                <mat-radio-button [value]="'YEAR'">Year</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <span class="invalid-message"> </span>
                </div>

                <div class="row mt-2 pt-1 segment-div-wrapper-up">
                    <div class="col-4 pl-0">
                        <label class="control-lbl required mt-2 label-cls">Prevailing wage paid - rate</label>
                        <input type="number" class="im-input" name="prevailingWageRate{{idx}}"
                            [(ngModel)]="lca.placeOfEmployments[idx].prvlWageRate" placeholder="Enter Amount in $"
                            #lca.placeOfEmployments[idx].prvlWageRate="ngModel" required />
                        <span class="invalid-message" *ngIf="!(lca.placeOfEmployments[idx].prvlWageRate)">
                            {{ getGlobalErrorMessages("REQUIRED") }}
                        </span>
                    </div>

                    <div class="col-6 pl-3">
                        <label class="control-lbl required mt-2 label-cls">Prevailing wage paid - per</label>
                        <div class="row">
                            <mat-radio-group class="pt-2" aria-label="Select an option" name="prevailingWagePer{{idx}}"
                                [(ngModel)]="lca.placeOfEmployments[idx].prvWageTypeCode"
                                #lca.placeOfEmployments[idx].prvWageTypeCode="ngModel" required>
                                <mat-radio-button [value]="'HOUR'">Hour</mat-radio-button>
                                <mat-radio-button [value]="'WEEK'">Week</mat-radio-button>
                                <mat-radio-button [value]="'BIWEEKLY'">Bi-Weekly</mat-radio-button>
                                <mat-radio-button [value]="'MONTH'">Month</mat-radio-button>
                                <mat-radio-button [value]="'YEAR'">Year</mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <span class="invalid-message"
                            *ngIf="(lca.placeOfEmployments[idx].wageRangeTypeCode !== lca.placeOfEmployments[idx].prvWageTypeCode)">
                            {{ getGlobalErrorMessages("INVALID_WAGE_PREVAILING") }}
                        </span>
                    </div>
                </div>


                <div class="row mb-3 pb-3">
                    <div class="col-6 mt-1 pl-0">
                        <label class="control-lbl required mt-2 label-cls">Prevailing wage level</label>
                        <div class="row">
                            <mat-radio-group class="pt-2" aria-label="Select an option" name="pwWageLevel{{idx}}"
                                #lca.placeOfEmployments[idx].prvWageLevelTypeCode="ngModel" required
                                [(ngModel)]="lca.placeOfEmployments[idx].prvWageLevelTypeCode">
                                <mat-radio-button [value]="'WAGELVL1'">I</mat-radio-button>
                                <mat-radio-button [value]="'WAGELVL2'">II</mat-radio-button>
                                <mat-radio-button [value]="'WAGELVL3'"> III</mat-radio-button>
                                <mat-radio-button [value]="'WAGELVL4'">IV </mat-radio-button>
                                <mat-radio-button [value]="'NOTAPPLCBL'">N/A </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <span class="invalid-message"> </span>
                </div>
            </div>
        </ng-container>

        <div class="row">
            <div class="col-md-6">
                <div class="pull-right flex-row">
                    <div (click)="handlePlaceOfEmptInfoCount(1)" matTooltip="Add new location info"
                        *ngIf="lca.placeOfEmployments.length<placeOfEmploymentInfoMaxCount" class="pointer flex-row">
                        <span class="primary pointer addItem material-icons"> add_circle</span>
                    </div>
                    <div (click)="handlePlaceOfEmptInfoCount(-1)" matTooltip="Remove this location info"
                        *ngIf="lca.placeOfEmployments.length>1" class="pl-2 pointer flex-row">
                        <span class="danger pointer removeItem material-icons"> remove_circle</span>
                    </div>
                </div>
            </div>
        </div>
        <!---------End Place of Employment Information-------------->
        <!-- <div class="row font-weight-bold text-primary linde-divider dasheedTopBorder pt-2">

            Enter the purpose for the LCA

        </div> -->
        <div>

            <div class="form-group col-md-8 pl-0 pt-2">
                <h5 class="labelText">Notes</h5>
                <input type="text" class="im-input" name="comment" [(ngModel)]="lca.comment"
                    placeholder="Enter Comment or Benificiary Name" #comment="ngModel" [readonly]="enableReadOnlyMode"
                    maxlength="60" />
            </div>

        </div>
        <div class="row pt-0 mt-0">
            <div class="col-6"></div>
            <div class="col-6 pt-0 mt-0">
                <p class="hintText">(Maximum 60 Characters)</p>
            </div>

        </div>
    </div>
    <div class="d-flex flex-row-reverse">
        <div>
            <lib-save-as-draft class="mr-2" confirmModelKey="savedraftfiledlca" styleClass="btn btn-primary"
                [disabled]="isSaveAsDraftDisabled" (onClickSaveAsDraft)="saveAsDraft($event)"
                [formToBeSaved]="f.form"></lib-save-as-draft>
            <button type="submit" class="btn btn-primary mt-0 mr-2" (click)="lcaAddNewFormSub(f)"
                [disabled]="f.form.invalid">Save</button>
            <button class="btn btn-primary mt-0" matStepperNext [disabled]="!lca.id">Next</button>
            <!-- <button class="btn btn-primary mt-0" matStepperNext [disabled]="!enableNextStepperButton">Next</button>
            </div> -->
        </div>
    </div>
</form>